import React, { memo, useState } from 'react';

import { Carousel } from 'react-bootstrap';

import Style from './CarouselSection.module.css';

import { CAROUSEL_INFO_VALUES } from '../constants';

const CarouselSection = memo(() => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className={Style.carouselContainer}>
      {/* <img src='/images/login/shapes.svg' style={{position: 'absolute', top: '-100px', left: '121px'}} /> */}
      <Carousel activeIndex={index} className={Style.carousel} onSelect={handleSelect}>
        {CAROUSEL_INFO_VALUES?.map((item) => (
          <Carousel.Item key={item?.title}>
            <div className={Style.carouselImgContainer}>
              <img alt='login illustration' src={item?.img} />
            </div>
            <Carousel.Caption>
              <div className={Style.captionHeader}>{item?.title}</div>
              <div className={Style.captionDetail}>{item?.details}</div>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
});

CarouselSection.displayName = 'CarouselSection';

export default CarouselSection;
